import './Parceiros.css'

import Container from 'react-bootstrap/Container';
import CaixaArredondada from '../CaixaArredondada';

const Parceiros = (props) => {
    var titulo1 = "INSTITUIÇÕES DE COORDENAÇÃO"
    var titulo2 = "PARCEIROS"
    var invertido = props.invertido
    if(props.linguagem == "en"){
        titulo1 = "COORDINATING INSTITUTIONS"
        titulo2 = "PARTNERS"
    }

    return(
        <Container>
            <CaixaArredondada titulo={titulo1} centralizado ={true} theme = {props.theme} cor_fundo_dark = "#E4E4E4" cor_fundo_light= "#E4E4E4">
                <a href="https://portal.fiocruz.br">
                    <img className="imagem fiocruz" title="Fundação Oswaldo Cruz - Fiocruz" src="imagens/logos_parceiros/fiocruz.png" alt="Fiocruz Logo"></img>
                </a>
                <a href="https://cidacs.bahia.fiocruz.br/">
                    <img className="imagem" title="Centro de Intregração de Dados e Conhecimentos para Saúde - Fiocruz" src="imagens/logos_parceiros/logo-cidacs.png" alt="Centro de Intregração de Dados e Conhecimentos para Saúde FIOCRUZ Logo"></img>
                </a>
                <a href="https://portal.fiocruz.br/programa-de-computacao-cientifica">
                    <img className="imagem" title='Programa de Computação Científica - Fiocruz' src="imagens/logos_parceiros/procc.jpg" alt="Programa de Computação Científica Logo"></img>
                </a>
                <a href="https://ufrj.br/">
                    <img className="imagem ufrj" title='UFRJ - Universidade Federal do Rio de Janeiro' src="imagens/logos_parceiros/ufrj-logo-13_.png" alt="UFRJ"></img>
                </a>
                <a href="https://www.coppe.ufrj.br/">
                    <img className="imagem coppe" title='COPPE - Instituto Alberto Luiz Coimbra de Pós-Graduação e Pesquisa em Engenharia - UFRJ' src="imagens/logos_parceiros/logo-coppe.png" alt="COPPE"></img>
                </a>
                <a href="https://www.lamce.coppe.ufrj.br/">
                    <img className="imagem lamce" title='LAMCE - Laboratório de Métodos Computacionais em Engenharia - COPPE - UFRJ' src="imagens/logos_parceiros/lamce.png" alt="LAMCE"></img>
                </a>
            </CaixaArredondada>
            <CaixaArredondada titulo={titulo2} centralizado ={true} theme = {props.theme} cor_fundo_dark = "#E4E4E4" cor_fundo_light= "#E4E4E4">
                <a href="https://ufba.br/">
                    <img className="imagem ufba" title='UFBA - Universidade Federal da Bahia' src="imagens/logos_parceiros/ufba_.png" alt="Universidade Federal da Bahia"></img>
                </a>
                <a href="https://uclouvain.be/fr/index.html">
                    <img className="imagem ucl" title='UCLouvain - Université catholique de Louvain' src="imagens/logos_parceiros/ucl_logo.png" alt="Université catholique de Louvain"></img>
                </a>
                <a href="https://www.ntu.edu.sg/">
                    <img className="imagem" title='Nanyang Technological University - Singapore' src="imagens/logos_parceiros/NTU-Logo.png" alt="NANYANG TECHNOLOGICAL UNIVERSITY - SINGAPURE"></img>
                </a>
                <a href="https://www.lshtm.ac.uk/">
                    <img className="imagem lshtm" title='London School of Hygiene & Tropical Medicine' src="imagens/logos_parceiros/lshtm-logo.png" alt="London School of Hygiene &amp; Tropical Medicine"></img>
                </a>
                <a href="https://www.unipd.it/en/">
                    <img className="imagem padua" title='Università Degli Studi Di Padova' src="imagens/logos_parceiros/padua-logo.png" alt="UNIVERSITY OF PADUA"></img>
                </a>
                <a href="https://www.rockefellerfoundation.org/">
                    <img className="imagem" title='The Rockefeller Foundation' src="imagens/logos_parceiros/therockefellerfondation_.png" alt="Rockefeller Foundation"></img>
                </a>
            </CaixaArredondada>
        </Container>
    )
}

export default Parceiros

